var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTrendingDown48Line = function SvgIconTrendingDown48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m37.42 20.93-3.4.08.14 5.84-8.03-8.03c-.66-.66-1.74-.66-2.4 0l-3.8 3.8-6.8-6.8-2.4 2.4 8 8c.66.66 1.74.66 2.4 0l3.8-3.8 6.77 6.77-5.73-.14-.08 3.4 8.77.21h.07a2.904 2.904 0 0 0 2.9-2.97l-.21-8.77v.01Z",
    fill: "current"
  })));
};
export default SvgIconTrendingDown48Line;